module.exports = __webpack_public_path__ + "static/media/cy.382ea817.webp";